import { Wrapper } from '@american-autonomy/ag-ui';

import { ICON_SIZE, LABEL, PLUS_END, PLUS_MIDDLE, PLUS_START, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const noop = (): void => {};

const NewOperationButton: FunctionComponent<Props> = ({
    className = '',
    onClick = noop,
    testId = TEST_ID
}) => (
    <button
        className={`${styles.button} ${className}`}
        data-testid={testId}
        onClick={onClick}
        type='button'>
        <svg
            aria-hidden='true'
            className={styles.icon}
            fill='none'
            height={ICON_SIZE}
            viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
            width={ICON_SIZE}
            xmlns='http://www.w3.org/2000/svg'>
            <line
                stroke='currentColor'
                strokeLinecap='round'
                strokeWidth='2'
                x1={PLUS_MIDDLE}
                x2={PLUS_MIDDLE}
                y1={PLUS_START}
                y2={PLUS_END}
            />

            <line
                stroke='currentColor'
                strokeLinecap='round'
                strokeWidth='2'
                x1={PLUS_START}
                x2={PLUS_END}
                y1={PLUS_MIDDLE}
                y2={PLUS_MIDDLE}
            />
        </svg>

        <Wrapper className={styles.label}>{LABEL}</Wrapper>
    </button>
);

export default NewOperationButton;
